var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.stepListClasses},_vm._l((_vm.steps),function(step,index){return _c('li',{key:index,class:_vm.itemClasses(index)},[_c('span',{staticClass:"num"},[_vm._v(" "+_vm._s(index + 1)+" ")]),_vm._v(" "+_vm._s(step.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }